import React from 'react';
export const arrowDown = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 34 34">
        <g fill="none" fillRule="evenodd">
            <path
                fill="#2D3742"
                d="M31.858 9.967l-14.372 16.8A.634.634 0 0 1 17 27c-.231 0-.393-.078-.486-.233L2.142 9.967c-.162-.178-.185-.39-.07-.634A.583.583 0 0 1 2.628 9h28.744c.255 0 .44.111.556.333.115.245.092.456-.07.634z"
            />
        </g>
    </svg>
);

export const arrowUp = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 34 34">
        <g fill="none" fillRule="evenodd">
            <path
                fill="#2D3742"
                d="M31.858 24.033c.162.178.185.39.07.634a.583.583 0 0 1-.556.333H2.628a.583.583 0 0 1-.556-.333c-.115-.245-.092-.456.07-.634l14.372-16.8C16.607 7.078 16.769 7 17 7c.185 0 .347.078.486.233l14.372 16.8z"
            />
        </g>
    </svg>
);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/arrows.jsx